import { render, staticRenderFns } from "./details-modal.vue?vue&type=template&id=a15c05e4&scoped=true"
import script from "./details-modal.vue?vue&type=script&lang=js"
export * from "./details-modal.vue?vue&type=script&lang=js"
import style0 from "./details-modal.vue?vue&type=style&index=0&id=a15c05e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15c05e4",
  null
  
)

export default component.exports